import { CategoryReducer } from './category.reducer';

export const reducers = CategoryReducer;
